// extracted by mini-css-extract-plugin
export default {"pointHistory":"styles_pointHistory__1dS6S","category":"styles_category__Zpa3z","pointItem":"styles_pointItem__Q7A22"};